/**
 * Owner-facing labels for the per-turn audit line (F050: never a raw rule or
 * category name at the owner).
 *
 * F201 — until now every `boundary_category` rendered the one generic
 * `conversations.audit.boundary` ("Fora do escopo"), which is actively
 * misleading for a `sensitive` turn: the bot forwarded that message to the
 * owner *because* it was personal, not because it was off-topic. Categories
 * that need their own wording get an entry here; everything else (crisis,
 * improper_conduct, regulated_opinion, owner, forbidden_scope, out_of_scope,
 * wants_human, and any future value) keeps the generic label.
 *
 * Kept as a module rather than inline in `TranscriptView` so the mapping is
 * unit-testable without rendering, and so a second audit surface cannot fork
 * the vocabulary.
 */
const BOUNDARY_LABEL_KEY: Record<string, string> = {
  sensitive: 'conversations.audit.sensitive',
};

const GENERIC_BOUNDARY_LABEL_KEY = 'conversations.audit.boundary';

/** Return the i18n key for a turn's `boundary_category` audit chip. */
export function boundaryLabelKey(category: string): string {
  return BOUNDARY_LABEL_KEY[category] ?? GENERIC_BOUNDARY_LABEL_KEY;
}
